<template>
    <div class="quillEditor">
      <quill-editor
        class="quill"
        :content="content"
        @change="onEditorChange($event)"
        :options="editorOption"
        :ref="quillId"
      >

      </quill-editor>
      <van-uploader :after-read="afterRead" class="upload" multiple :id="quillId+'Upload'">
        <van-icon name="plus" />
        <p>上传图片</p>
      </van-uploader>
    </div>
</template>
<script>
  import imageCompression from 'browser-image-compression';

  const toolbarOptions = [
    ['bold', 'italic', 'underline',{ 'color': [] }, { 'background': [] }],        // toggled buttons
    ['image',{ 'list': 'ordered'}, { 'list': 'bullet' },{ 'align': [] }],
  ]
    export default{
        data(){
            return {
              editorOption: {
                modules: {
                  toolbar: {
                    container: toolbarOptions,  // 工具栏
                    handlers: {
                      'image': ()=> {
                        var fileInput = document.getElementById(this.quillId+'Upload') //隐藏的文本ID
                        fileInput.click() //加一个触发事件
                      }
                    }
                  },
                  ImageResize : {
                    displaySize: true
                  }
                }
              },
            }
        },
        props:{
          content:'',
          quillId:''
        },
        methods:{
          onEditorChange(editor) {
            this.$emit('change',editor)
          },
          async afterRead(files){
            console.log(files.constructor)
            if(files.constructor === Array){
              if(files.length>99){
                this.$title('图片不能超过99张')
                return
              }
              for(var item of files){
                await this.onRead(item)
              }
            }else if(files.constructor === Object){
              this.onRead(files)
            }
          },
          async onRead(file){
            var fileSrc = file.file;

            var isImg = this.$wxuserUtil.validateIsImg(fileSrc);
            if(!isImg){
              return;
            }

            this.$toast({
              mask: true,
              duration:2,
              message: '上传中...'
            });

            let lastFile = await imageCompression(fileSrc,this.$wxuserUtil.compressImgOptions);

            var formData = new FormData()
            formData.append('salesId',this.$wxuserUtil.getUserId())
            formData.append('file',lastFile)
            console.log(file)
            return  this.$api.uploadFile(formData).then(response=>{
              if(response.success==true){
                  console.log(this.quillId)
                let quill = this.$refs[this.quillId].quill
                console.log(quill)
                // 获取光标所在位置
                let length = quill.getSelection().index;
                // 插入图片，res为服务器返回的图片链接地址
                quill.insertEmbed(length, 'image',this.$http+'upload/'+ response.data.fileName)
                // 调整光标到最后
                quill.setSelection(length + 1)
              }else{
//                this.imgs.splice(this.imgs.length-1,1);
                this.$topTip(this,`图片上传失败,${response.msg}`);
              }
            })
          },
        }
    }
</script>
<style scoped lang="less" rel="stylesheet/less">
  .quillEditor{
    position: relative;
  }
  .quill{
    position: relative;
    z-index: 2;
  }
  .upload{
    position: absolute;
    opacity: 0;
    z-index: 1;
    top:0;
    left:0
}
</style>



// WEBPACK FOOTER //
// src/components/active/component/quillEditImg.vue